// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M6.5 2H2V22H22V2H17.5V9.875H6.5V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M15.5 2H8.5V7.875H15.5V2ZM14 4V7H12V4H14Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-hard-disk-storage-filled')
export default class HardDiskStorageFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'hard-disk-storage-filled',
    }
  }
}
